module.exports = __webpack_public_path__ + "img/wall_shadow.20a15183.png";